<template>
    <div>
        <header-layout/>
        <div>
            <router-view/>
        </div>
        <footer-layout/>
    </div>
</template>

<script setup>
import HeaderLayout from "@/components/layout/HeaderLayout.vue";
import FooterLayout from "@/components/layout/FooterLayout.vue";
</script>
